import React from 'react';
import type { DashboardStats } from '../../models/DashboardStats';
import { FailureReasonsWidget } from '../FailureReasons';
import { UserRankingWidget } from '../UserRanking';
import { HourlyHeatmap } from '../HourlyHeatmap';

interface DashboardLayoutCPProps {
  data: DashboardStats;
}

export const DashboardLayoutCP: React.FC<DashboardLayoutCPProps> = ({
  data,
}) => (
  <>
    <div className='lg:col-span-1'>
      <FailureReasonsWidget data={data.failureReasons} />
    </div>
    <div className='md:col-span-2 lg:col-span-2'>
      <UserRankingWidget data={data.usersRanking} />
    </div>
    <div className='md:col-span-2 lg:col-span-3 min-h-[300px]'>
      <HourlyHeatmap data={data.heatmap} />
    </div>
  </>
);
